import { hasFullOpsAccess } from "./roles.js";

export default class Permission {
  setControls(path) {
    let status;
    if (!hasFullOpsAccess()) {
      if (localStorage.getItem("Zoz_controls")) {
        let controls = JSON.parse(localStorage.getItem("Zoz_controls"));
        const found = controls.find((control) => control.url == path);

        if (found) {
          status = false;
        } else {
          status = true;
        }
      }
    } else {
      status = false;
    }
    return status;
  }
  allowed(path) {
    let status;
    if (!hasFullOpsAccess()) {
      if (localStorage.getItem("Zoz_permissions")) {
        let controls = JSON.parse(localStorage.getItem("Zoz_permissions"));

        const found = controls.find((control) => control.url == path);
        console.log(found);
        if (found) {
          status = false;
        } else {
          status = true;
        }
      }
    } else {
      status = false;
    }
    return status;
  }
}
